import { render, staticRenderFns } from "./AppPayment.vue?vue&type=template&id=f002227a"
import script from "./AppPayment.vue?vue&type=script&lang=js"
export * from "./AppPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports